import { render } from "./PostImage.vue?vue&type=template&id=5fe1d419"
import script from "./PostImage.vue?vue&type=script&lang=js"
export * from "./PostImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__